
<div class="container-fluid full-width-image flex-column align-items-between">
  <!-- <div class="auth-container"> -->
    <div class="portal-header">
      <h1 class="text-center" translate>Welcome</h1>
      <h2 translate>Sitetitle</h2>
    </div>
    <div>
      <router-outlet></router-outlet>
    </div>
    <div>
      <app-footer [privacy]="false"></app-footer>
    </div>
  <!-- </div> -->
</div>
